import React, { useCallback, useEffect, useState } from 'react';
import MessageCarousel from './components/MessagesCarousel';
import { useAppNavigate } from '..';
import { Stashboard, getStashboardData, useSpringBigStore } from '@springbig/shared';
import { useAuthorization } from '~/hooks/auth';
import Loading from '~/shared/Loading';
import { Section } from '~/shared/Theme';
import { Caption } from '~/shared/Typography';

const MessageDetailScreen = () => {

    const { params } = useAppNavigate();
    const { isLoadingAuth } = useAuthorization();
    const [data, setData] = useState<Stashboard | null>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { member, setStashboardTarget, stashboards, setLayoutEnabled } = useSpringBigStore();

    const getMessage = useCallback(async (stashboard_key: string) => {

        const alreadyFetchedStashboard = stashboards?.find((s) => s._key === stashboard_key);

        if (alreadyFetchedStashboard?.redirect_url) {
            window.location.replace(alreadyFetchedStashboard.redirect_url);
            return;
        }

        if (alreadyFetchedStashboard) {
            setData(alreadyFetchedStashboard);
            return;
        }

        setIsLoading(true);

        const result = member && await getStashboardData({
            stashboard_key,
            type: 'sms',
        });

        if (result?.redirect_url) {
            window.location.replace(result.redirect_url);
            return;
        }

        result && setData(result);
        setIsLoading(false);
    }, [member]);

    useEffect(() => {

        if (params && params.stashboard_key) {
            setStashboardTarget(params.stashboard_key);
            getMessage(params.stashboard_key);
        }
    }, [member, params.wallet_id, params.stashboard_key, getMessage]);

    const isSafari = () => {
        const ua = navigator.userAgent;
        const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
        return isSafari;
    };

    useEffect(() => {

        if (data && data?.content_type === 'gated_link' && data?.redirect_link && location?.pathname?.includes('m') && location?.pathname?.includes('messages')) {
            if (isSafari()) {
                requestAnimationFrame(() => {
                    setLayoutEnabled((prev: boolean) => false);
                    window.location.href = data.redirect_link;
                });
            } else {
                setLayoutEnabled((prev: boolean) => false);
                window.location.href = data.redirect_link;
            }
        } else {
            setLayoutEnabled((prev: boolean) => true);
        }
    }, [data, location?.pathname]);

    if (isLoading || isLoadingAuth || (data && data?.content_type === 'gated_link' && data?.redirect_link)) {
        return <Loading isLoading={true} />;
    }


    return (
        <Section display={'block'}>
            <Caption>
                {`${Boolean(data && data?.content_type === 'gated_link' && data?.redirect_link && location?.pathname?.includes('m') && location?.pathname?.includes('messages'))}`}
            </Caption>
            <Caption>
                {`${data.content_type}`}
            </Caption>
            { data && data?.content_type !== 'gated_link' &&
                <MessageCarousel data={data} />
            }
        </Section>
    );
};

export default MessageDetailScreen;
